export default __webpack_public_path__ + "static/media/mars14.9fd7c7ba.gif";